import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import UndoIcon from "@mui/icons-material/Undo";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import {
  convertCurrencyFormat,
  formatToStandardDate,
} from "../../helper/common";

const IncomeSourceCard = ({
  userId,
  amount,
  type,
  selectedSource = [],
  changeSelectedSource,
  onDelete,
  isDeleting = false,
  isPendingDelete = false,
  onCancelPendingDelete,
}) => {
  const { _t } = useTranslator();
  const [isActive, setIsActive] = useState(selectedSource?.includes(type));

  useEffect(() => {
    setIsActive(selectedSource?.includes(type));
  }, [selectedSource]);

  const handleChange = () => {
    changeSelectedSource(userId, type);
  };

  const isMonthlyIncome =
    type.startsWith("payslip:") ||
    type === "declaredIncome" ||
    type === "bank" ||
    type.startsWith("custom_income:");

  return (
    <div
      className={`income-source-card-wrapper ${
        isActive ? "income-source-card-wrapper-active" : ""
      } ${isPendingDelete ? "income-source-card-wrapper-pending-delete" : ""}`}
      onClick={handleChange}
      style={{ position: "relative", opacity: isPendingDelete ? 0.5 : 1 }}
    >
      <div className="d-flex align-items-center about-source">
        <div className="default-checkbox d-flex align-items-center justify-content-center">
          {isActive && <CheckOutlinedIcon />}
        </div>
        <div
          className="d-flex flex-column flex-1 w-100"
          style={{
            paddingRight: type.startsWith("custom_income:") ? "24px" : "0",
          }}
        >
          <div className="d-flex justify-content-between flex-1 align-items-center">
            <h4 style={{ display: "flex", alignItems: "center" }}>
              {type.startsWith("payslip:")
                ? (() => {
                    const [, rawDate, employer] = type.split(":");
                    const formattedDate = formatToStandardDate(rawDate?.trim());
                    return employer?.trim()
                      ? `${_t("payslip")} – ${employer.trim()} (${formattedDate})`
                      : `${_t("payslip")} (${formattedDate})`;
                  })()
                : type.startsWith("custom_income:")
                  ? type.replace("custom_income:", "")
                  : _t(type)}{" "}
            </h4>
            <span
              className={`monthly-badge ${!isMonthlyIncome ? "annual-badge" : ""}`}
            >
              {isMonthlyIncome
                ? `${_t("monthly")}`
                : `${_t("annualInPayslip")}`}
            </span>
          </div>
          <h6>
            {/* {!isMonthlyIncome ? <span>{`${_t("annual")} • `}</span> : null} */}
            {convertCurrencyFormat(amount)}€
            {!isMonthlyIncome &&
              ` -> ` +
                convertCurrencyFormat(Math.round(amount / 12)) +
                "€/" +
                _t("mo")}
          </h6>
        </div>
      </div>
      {type.startsWith("custom_income:") && (
        <div
          style={{
            position: "absolute",
            top: "-6px",
            right: "-6px",
            zIndex: 10,
            borderRadius: "50%",
            backgroundColor: "#fff",
            height: "22px",
            width: "22px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "0.2px solid #e2eaf0",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {isPendingDelete ? (
            <UndoIcon
              onClick={onCancelPendingDelete}
              style={{
                cursor: "pointer",
                color: "#4CAF50",
                fontSize: "1.5rem",
              }}
            />
          ) : isDeleting ? (
            <CircularProgress size={16} style={{ color: "#FF3C3C" }} />
          ) : onDelete ? (
            <ClearOutlinedIcon
              onClick={onDelete}
              style={{
                cursor: "pointer",
                color: "#FF3C3C",
                fontSize: "1rem",
              }}
            />
          ) : null}
        </div>
      )}
    </div>
  );
};

export default IncomeSourceCard;
